export const DirectOrderCheckpointLabelTextHelper = {
    getLabelText: {
        directOrderNumber: 'Direct Order Number',
        checkpointTimeUtc: 'Checkpoint Time (UTC)',
        checkpointTimeLocal: 'Converted current browser local timezone',
        directOrderCheckpointList: 'Direct order checkpoint list',
        tag: 'tag',
        subTag: 'subTag',
        message: 'message'
    }
};
